// Safe console wrapper that won't break if console is missing
export const log = typeof console !== 'undefined' ? console.log.bind(console) : () => {};

// Make available globally for legacy code
window.log = log;
